// extracted by mini-css-extract-plugin
export default {"body":"Category_body__Ir2EJ","items":"Category_items__APVwr"};